"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_generated_exports = {};
__export(types_generated_exports, {
  isAccessToken: () => isAccessToken,
  isAccountNotFound: () => isAccountNotFound,
  isCheckResetPasswordTokenResponse: () => isCheckResetPasswordTokenResponse,
  isCheckResetPasswordTokenResult: () => isCheckResetPasswordTokenResult,
  isCheckSigninEmailResponse: () => isCheckSigninEmailResponse,
  isCheckWorkspaceAccessResult: () => isCheckWorkspaceAccessResult,
  isCredentials: () => isCredentials,
  isForgotPasswordRequest: () => isForgotPasswordRequest,
  isIdentity: () => isIdentity,
  isInvalidEmail: () => isInvalidEmail,
  isInvitationAcceptResponse: () => isInvitationAcceptResponse,
  isInvitationAccepted: () => isInvitationAccepted,
  isInvitationChallenge: () => isInvitationChallenge,
  isInvitationChallengeAlreadyAccepted: () => isInvitationChallengeAlreadyAccepted,
  isInvitationChallengeCanceled: () => isInvitationChallengeCanceled,
  isInvitationChallengeExpired: () => isInvitationChallengeExpired,
  isInvitationChallengeIncorrectEmail: () => isInvitationChallengeIncorrectEmail,
  isInvitationChallengeNotFound: () => isInvitationChallengeNotFound,
  isInvitationChallengeSignupRequired: () => isInvitationChallengeSignupRequired,
  isInvitationCodeChallenge: () => isInvitationCodeChallenge,
  isInvitationCodeChallengeAlreadyUsed: () => isInvitationCodeChallengeAlreadyUsed,
  isInvitationCodeChallengeCanceled: () => isInvitationCodeChallengeCanceled,
  isInvitationCodeChallengeExpired: () => isInvitationCodeChallengeExpired,
  isInvitationCodeChallengeLimitsReached: () => isInvitationCodeChallengeLimitsReached,
  isInvitationCodeChallengeNotFound: () => isInvitationCodeChallengeNotFound,
  isInvitationCodeChallengeRolesUnchanged: () => isInvitationCodeChallengeRolesUnchanged,
  isInvitationCodeSignupAlreadyApproved: () => isInvitationCodeSignupAlreadyApproved,
  isInvitationCodeSignupAlreadyRejected: () => isInvitationCodeSignupAlreadyRejected,
  isInvitationCodeSignupApprovalRequest: () => isInvitationCodeSignupApprovalRequest,
  isInvitationCodeSignupApprovalResponse: () => isInvitationCodeSignupApprovalResponse,
  isInvitationCodeSignupApproved: () => isInvitationCodeSignupApproved,
  isInvitationCodeSignupRejected: () => isInvitationCodeSignupRejected,
  isInvitationCodeSignupRequest: () => isInvitationCodeSignupRequest,
  isInvitationCodeUseRequest: () => isInvitationCodeUseRequest,
  isInvitationSignupChallenge: () => isInvitationSignupChallenge,
  isInvitationSignupChallengeAlreadyAccepted: () => isInvitationSignupChallengeAlreadyAccepted,
  isInvitationSignupChallengeCanceled: () => isInvitationSignupChallengeCanceled,
  isInvitationSignupChallengeEmailVerificationRequired: () => isInvitationSignupChallengeEmailVerificationRequired,
  isInvitationSignupChallengeExpired: () => isInvitationSignupChallengeExpired,
  isInvitationSignupChallengeValidationErrors: () => isInvitationSignupChallengeValidationErrors,
  isInvitationSignupRequest: () => isInvitationSignupRequest,
  isInvitationSignupResponse: () => isInvitationSignupResponse,
  isPasswordIncorrect: () => isPasswordIncorrect,
  isPasswordRequired: () => isPasswordRequired,
  isResetPasswordFailed: () => isResetPasswordFailed,
  isResetPasswordRequest: () => isResetPasswordRequest,
  isResetPasswordResult: () => isResetPasswordResult,
  isResetPasswordSignInRequired: () => isResetPasswordSignInRequired,
  isResetPasswordSignedIn: () => isResetPasswordSignedIn,
  isResetPasswordToken: () => isResetPasswordToken,
  isSigninChallenge: () => isSigninChallenge,
  isSigninRequest: () => isSigninRequest,
  isSigninResponse: () => isSigninResponse,
  isSigninSuccess: () => isSigninSuccess,
  isSignupChallenge: () => isSignupChallenge,
  isSignupChallengeCodeCanceled: () => isSignupChallengeCodeCanceled,
  isSignupChallengeCodeExpired: () => isSignupChallengeCodeExpired,
  isSignupChallengeCodeNotFound: () => isSignupChallengeCodeNotFound,
  isSignupChallengeEmailVerificationRequired: () => isSignupChallengeEmailVerificationRequired,
  isSignupChallengeLimitsReached: () => isSignupChallengeLimitsReached,
  isSignupChallengeValidationErrors: () => isSignupChallengeValidationErrors,
  isSignupResponse: () => isSignupResponse,
  isTermsNotAccepted: () => isTermsNotAccepted,
  isWorkspaceAccessDenied: () => isWorkspaceAccessDenied,
  isWorkspaceAccessDeniedReason: () => isWorkspaceAccessDeniedReason,
  isWorkspaceAccessGranted: () => isWorkspaceAccessGranted,
  isWorkspaceAccessUnapproved: () => isWorkspaceAccessUnapproved
});
module.exports = __toCommonJS(types_generated_exports);
var import_types_generated = require("../core/types.generated.js");
var import_types_generated2 = require("../permission/types.generated.js");
var import_util = require("@cartographerio/util");
const isAccessToken = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "AccessToken")(v);
};
const isIdentity = (v) => {
  return typeof v === "object" && v != null && "userId" in v && (0, import_types_generated.isUserId)(v.userId) && "firstName" in v && typeof v.firstName === "string" && "lastName" in v && typeof v.lastName === "string" && "screenName" in v && (0, import_types_generated.isScreenName)(v.screenName) && "email" in v && (0, import_types_generated.isEmail)(v.email) && "roles" in v && Array.isArray(v.roles) && v.roles.every((i) => (0, import_types_generated2.isRole)(i)) && "qualificationRoles" in v && Array.isArray(v.qualificationRoles) && v.qualificationRoles.every((i) => (0, import_types_generated2.isQualificationRole)(i)) && (!("features" in v) || Array.isArray(v.features) && v.features.every((i) => (0, import_types_generated.isUserFeature)(i)) || v.features === null);
};
const isCredentials = (v) => {
  return typeof v === "object" && v != null && "token" in v && isAccessToken(v.token) && "identity" in v && isIdentity(v.identity);
};
const isInvitationSignupRequest = (v) => {
  return typeof v === "object" && v != null && "firstName" in v && typeof v.firstName === "string" && "lastName" in v && typeof v.lastName === "string" && "email" in v && (0, import_types_generated.isEmail)(v.email) && "screenName" in v && (0, import_types_generated.isScreenName)(v.screenName) && "password" in v && (0, import_types_generated.isUnencryptedPassword)(v.password) && "acceptTerms" in v && typeof v.acceptTerms === "boolean";
};
const isInvitationChallengeNotFound = (v) => {
  return typeof v === "object" && v != null && "invitation" in v && (0, import_types_generated.isInvitationId)(v.invitation);
};
const isInvitationChallengeExpired = (v) => {
  return typeof v === "object" && v != null && "invitation" in v && (0, import_types_generated.isInvitationId)(v.invitation);
};
const isInvitationChallengeCanceled = (v) => {
  return typeof v === "object" && v != null && "invitation" in v && (0, import_types_generated.isInvitationId)(v.invitation);
};
const isInvitationChallengeAlreadyAccepted = (v) => {
  return typeof v === "object" && v != null && "invitation" in v && (0, import_types_generated.isInvitationId)(v.invitation);
};
const isInvitationChallengeIncorrectEmail = (v) => {
  return typeof v === "object" && v != null && "invitation" in v && (0, import_types_generated.isInvitationId)(v.invitation);
};
const isInvitationChallengeSignupRequired = (v) => {
  return typeof v === "object" && v != null && "invitation" in v && (0, import_types_generated.isInvitationId)(v.invitation) && "firstName" in v && typeof v.firstName === "string" && "lastName" in v && typeof v.lastName === "string" && "email" in v && (0, import_types_generated.isEmail)(v.email);
};
const isInvitationChallenge = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "InvitationChallengeAlreadyAccepted" && isInvitationChallengeAlreadyAccepted(v) || v.type === "InvitationChallengeCanceled" && isInvitationChallengeCanceled(v) || v.type === "InvitationChallengeExpired" && isInvitationChallengeExpired(v) || v.type === "InvitationChallengeIncorrectEmail" && isInvitationChallengeIncorrectEmail(v) || v.type === "InvitationChallengeNotFound" && isInvitationChallengeNotFound(v) || v.type === "InvitationChallengeSignupRequired" && isInvitationChallengeSignupRequired(v));
};
const isInvitationAccepted = (v) => {
  return typeof v === "object" && v != null && "invitationId" in v && (0, import_types_generated.isInvitationId)(v.invitationId) && "userId" in v && (0, import_types_generated.isUserId)(v.userId);
};
const isInvitationAcceptResponse = (v) => {
  return isInvitationChallenge(v) || typeof v === "object" && v != null && "type" in v && v.type === "InvitationAccepted" && isInvitationAccepted(v);
};
const isInvitationCodeUseRequest = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode) && "user" in v && ((0, import_types_generated.isUserId)(v.user) || (0, import_types_generated.isEmail)(v.user));
};
const isInvitationCodeSignupRequest = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode) && "firstName" in v && typeof v.firstName === "string" && "lastName" in v && typeof v.lastName === "string" && "email" in v && (0, import_types_generated.isEmail)(v.email) && "screenName" in v && (0, import_types_generated.isScreenName)(v.screenName) && "acceptTerms" in v && typeof v.acceptTerms === "boolean";
};
const isInvitationCodeChallengeNotFound = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode);
};
const isInvitationCodeChallengeExpired = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode);
};
const isInvitationCodeChallengeCanceled = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode);
};
const isInvitationCodeChallengeAlreadyUsed = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode);
};
const isInvitationCodeChallengeRolesUnchanged = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode);
};
const isInvitationCodeChallengeLimitsReached = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode) && "message" in v && typeof v.message === "string";
};
const isInvitationCodeChallenge = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "InvitationCodeChallengeAlreadyUsed" && isInvitationCodeChallengeAlreadyUsed(v) || v.type === "InvitationCodeChallengeCanceled" && isInvitationCodeChallengeCanceled(v) || v.type === "InvitationCodeChallengeExpired" && isInvitationCodeChallengeExpired(v) || v.type === "InvitationCodeChallengeLimitsReached" && isInvitationCodeChallengeLimitsReached(v) || v.type === "InvitationCodeChallengeNotFound" && isInvitationCodeChallengeNotFound(v) || v.type === "InvitationCodeChallengeRolesUnchanged" && isInvitationCodeChallengeRolesUnchanged(v));
};
const isSignupChallengeCodeNotFound = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode);
};
const isSignupChallengeCodeExpired = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode);
};
const isSignupChallengeCodeCanceled = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode);
};
const isSignupChallengeLimitsReached = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode) && "message" in v && typeof v.message === "string";
};
const isSignupChallengeEmailVerificationRequired = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode);
};
const isSignupChallengeValidationErrors = (v) => {
  return typeof v === "object" && v != null && "errors" in v && Array.isArray(v.errors) && v.errors.every((i) => (0, import_types_generated.isMessage)(i));
};
const isSignupChallenge = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "SignupChallengeCodeCanceled" && isSignupChallengeCodeCanceled(v) || v.type === "SignupChallengeCodeExpired" && isSignupChallengeCodeExpired(v) || v.type === "SignupChallengeCodeNotFound" && isSignupChallengeCodeNotFound(v) || v.type === "SignupChallengeEmailVerificationRequired" && isSignupChallengeEmailVerificationRequired(v) || v.type === "SignupChallengeLimitsReached" && isSignupChallengeLimitsReached(v) || v.type === "SignupChallengeValidationErrors" && isSignupChallengeValidationErrors(v));
};
const isSignupResponse = (v) => {
  return isSignupChallenge(v) || typeof v === "object" && v != null && "type" in v && v.type === "SignupSuccess" && "credentials" in v && isCredentials(v.credentials);
};
const isInvitationSignupChallengeExpired = (v) => {
  return typeof v === "object" && v != null && "invitation" in v && (0, import_types_generated.isInvitationId)(v.invitation);
};
const isInvitationSignupChallengeCanceled = (v) => {
  return typeof v === "object" && v != null && "invitation" in v && (0, import_types_generated.isInvitationId)(v.invitation);
};
const isInvitationSignupChallengeAlreadyAccepted = (v) => {
  return typeof v === "object" && v != null && "invitation" in v && (0, import_types_generated.isInvitationId)(v.invitation);
};
const isInvitationSignupChallengeEmailVerificationRequired = (v) => {
  return typeof v === "object" && v != null && "invitation" in v && (0, import_types_generated.isInvitationId)(v.invitation);
};
const isInvitationSignupChallengeValidationErrors = (v) => {
  return typeof v === "object" && v != null && "errors" in v && Array.isArray(v.errors) && v.errors.every((i) => (0, import_types_generated.isMessage)(i));
};
const isInvitationSignupChallenge = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "InvitationSignupChallengeAlreadyAccepted" && isInvitationSignupChallengeAlreadyAccepted(v) || v.type === "InvitationSignupChallengeCanceled" && isInvitationSignupChallengeCanceled(v) || v.type === "InvitationSignupChallengeEmailVerificationRequired" && isInvitationSignupChallengeEmailVerificationRequired(v) || v.type === "InvitationSignupChallengeExpired" && isInvitationSignupChallengeExpired(v) || v.type === "InvitationSignupChallengeValidationErrors" && isInvitationSignupChallengeValidationErrors(v));
};
const isInvitationSignupResponse = (v) => {
  return isInvitationSignupChallenge(v) || typeof v === "object" && v != null && "type" in v && v.type === "SignupSuccess" && "credentials" in v && isCredentials(v.credentials);
};
const isInvitationCodeSignupApprovalRequest = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode) && "user" in v && ((0, import_types_generated.isUserId)(v.user) || (0, import_types_generated.isEmail)(v.user));
};
const isInvitationCodeSignupApproved = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode) && "userId" in v && (0, import_types_generated.isUserId)(v.userId) && "emailVerificationRequired" in v && typeof v.emailVerificationRequired === "boolean";
};
const isInvitationCodeSignupRejected = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode) && "userId" in v && (0, import_types_generated.isUserId)(v.userId);
};
const isInvitationCodeSignupAlreadyApproved = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode) && "userId" in v && (0, import_types_generated.isUserId)(v.userId);
};
const isInvitationCodeSignupAlreadyRejected = (v) => {
  return typeof v === "object" && v != null && "invitationCode" in v && (0, import_types_generated.isInvitationCodeRef)(v.invitationCode) && "userId" in v && (0, import_types_generated.isUserId)(v.userId);
};
const isInvitationCodeSignupApprovalResponse = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "InvitationCodeSignupAlreadyApproved" && isInvitationCodeSignupAlreadyApproved(v) || v.type === "InvitationCodeSignupAlreadyRejected" && isInvitationCodeSignupAlreadyRejected(v) || v.type === "InvitationCodeSignupApproved" && isInvitationCodeSignupApproved(v) || v.type === "InvitationCodeSignupRejected" && isInvitationCodeSignupRejected(v));
};
const isSigninRequest = (v) => {
  return typeof v === "object" && v != null && "email" in v && typeof v.email === "string" && (!("password" in v) || (0, import_types_generated.isUnencryptedPassword)(v.password) || v.password === null) && (!("invitationCode" in v) || (0, import_types_generated.isInvitationCodeRef)(v.invitationCode) || v.invitationCode === null) && (!("signinAs" in v) || (0, import_types_generated.isEmail)(v.signinAs) || v.signinAs === null) && (!("acceptTerms" in v) || typeof v.acceptTerms === "boolean" || v.acceptTerms === null);
};
const isInvalidEmail = (v) => {
  return typeof v === "object" && v != null && "email" in v && typeof v.email === "string";
};
const isAccountNotFound = (v) => {
  return typeof v === "object" && v != null && "email" in v && typeof v.email === "string";
};
const isPasswordRequired = (v) => {
  return typeof v === "object" && v != null && "email" in v && (0, import_types_generated.isEmail)(v.email);
};
const isPasswordIncorrect = (v) => {
  return typeof v === "object" && v != null && "email" in v && (0, import_types_generated.isEmail)(v.email);
};
const isTermsNotAccepted = (v) => {
  return typeof v === "object" && v != null && "email" in v && (0, import_types_generated.isEmail)(v.email) && "version" in v && typeof v.version === "number";
};
const isSigninChallenge = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "InvalidEmail" && isInvalidEmail(v) || v.type === "AccountNotFound" && isAccountNotFound(v) || v.type === "PasswordRequired" && isPasswordRequired(v) || v.type === "PasswordIncorrect" && isPasswordIncorrect(v) || v.type === "TermsNotAccepted" && isTermsNotAccepted(v));
};
const isSigninSuccess = (v) => {
  return typeof v === "object" && v != null && "credentials" in v && isCredentials(v.credentials) && (!("codeChallenge" in v) || isInvitationCodeChallenge(v.codeChallenge) || v.codeChallenge === null);
};
const isSigninResponse = (v) => {
  return isSigninChallenge(v) || typeof v === "object" && v != null && "type" in v && v.type === "SigninSuccess" && isSigninSuccess(v);
};
const isResetPasswordToken = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "ResetPasswordToken")(v);
};
const isForgotPasswordRequest = (v) => {
  return typeof v === "object" && v != null && "email" in v && (0, import_types_generated.isEmail)(v.email);
};
const isResetPasswordRequest = (v) => {
  return typeof v === "object" && v != null && "token" in v && isResetPasswordToken(v.token) && "password" in v && (0, import_types_generated.isUnencryptedPassword)(v.password);
};
const isResetPasswordSignedIn = (v) => {
  return typeof v === "object" && v != null && "credentials" in v && isCredentials(v.credentials) && "result" in v && isCheckResetPasswordTokenResult(v.result);
};
const isResetPasswordSignInRequired = (v) => {
  return typeof v === "object" && v != null && "result" in v && isCheckResetPasswordTokenResult(v.result);
};
const isResetPasswordFailed = (v) => {
  return typeof v === "object" && v != null && "result" in v && isCheckResetPasswordTokenResult(v.result);
};
const isResetPasswordResult = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "ResetPasswordSignedIn" && isResetPasswordSignedIn(v) || v.type === "ResetPasswordSignInRequired" && isResetPasswordSignInRequired(v) || v.type === "ResetPasswordFailed" && isResetPasswordFailed(v));
};
const isCheckSigninEmailResponse = (v) => {
  return typeof v === "object" && v != null && "exists" in v && typeof v.exists === "boolean";
};
const isCheckResetPasswordTokenResult = (v) => {
  return v === "expired" || v === "invalid" || v === "valid";
};
const isCheckResetPasswordTokenResponse = (v) => {
  return typeof v === "object" && v != null && "token" in v && isResetPasswordToken(v.token) && "result" in v && isCheckResetPasswordTokenResult(v.result);
};
const isWorkspaceAccessDeniedReason = (v) => {
  return v === "AccountDisabled" || v === "WorkspaceDisabled" || v === "NoAccess";
};
const isWorkspaceAccessGranted = (v) => {
  return typeof v === "object" && v != null && "id" in v && (0, import_types_generated.isWorkspaceId)(v.id) && "userId" in v && (0, import_types_generated.isUserId)(v.userId) && "name" in v && typeof v.name === "string" && "alias" in v && (0, import_types_generated.isWorkspaceAlias)(v.alias) && (!("logo" in v) || typeof v.logo === "string" || v.logo === null) && (!("pendingInvitationCodeIds" in v) || Array.isArray(v.pendingInvitationCodeIds) && v.pendingInvitationCodeIds.every((i) => (0, import_types_generated.isInvitationCodeId)(i)) || v.pendingInvitationCodeIds === null) && (!("pendingRoles" in v) || Array.isArray(v.pendingRoles) && v.pendingRoles.every((i) => (0, import_types_generated2.isRole)(i)) || v.pendingRoles === null);
};
const isWorkspaceAccessUnapproved = (v) => {
  return typeof v === "object" && v != null && "id" in v && (0, import_types_generated.isWorkspaceId)(v.id) && "userId" in v && (0, import_types_generated.isUserId)(v.userId) && "name" in v && typeof v.name === "string" && "alias" in v && (0, import_types_generated.isWorkspaceAlias)(v.alias) && (!("logo" in v) || typeof v.logo === "string" || v.logo === null) && "pendingInvitationCodeIds" in v && Array.isArray(v.pendingInvitationCodeIds) && v.pendingInvitationCodeIds.every((i) => (0, import_types_generated.isInvitationCodeId)(i)) && "pendingRoles" in v && Array.isArray(v.pendingRoles) && v.pendingRoles.every((i) => (0, import_types_generated2.isRole)(i));
};
const isWorkspaceAccessDenied = (v) => {
  return typeof v === "object" && v != null && "id" in v && (0, import_types_generated.isWorkspaceId)(v.id) && "reason" in v && isWorkspaceAccessDeniedReason(v.reason) && "userId" in v && (0, import_types_generated.isUserId)(v.userId) && "name" in v && typeof v.name === "string" && "alias" in v && (0, import_types_generated.isWorkspaceAlias)(v.alias) && (!("logo" in v) || typeof v.logo === "string" || v.logo === null);
};
const isCheckWorkspaceAccessResult = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "WorkspaceAccessDenied" && isWorkspaceAccessDenied(v) || v.type === "WorkspaceAccessGranted" && isWorkspaceAccessGranted(v) || v.type === "WorkspaceAccessUnapproved" && isWorkspaceAccessUnapproved(v));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isAccessToken,
  isAccountNotFound,
  isCheckResetPasswordTokenResponse,
  isCheckResetPasswordTokenResult,
  isCheckSigninEmailResponse,
  isCheckWorkspaceAccessResult,
  isCredentials,
  isForgotPasswordRequest,
  isIdentity,
  isInvalidEmail,
  isInvitationAcceptResponse,
  isInvitationAccepted,
  isInvitationChallenge,
  isInvitationChallengeAlreadyAccepted,
  isInvitationChallengeCanceled,
  isInvitationChallengeExpired,
  isInvitationChallengeIncorrectEmail,
  isInvitationChallengeNotFound,
  isInvitationChallengeSignupRequired,
  isInvitationCodeChallenge,
  isInvitationCodeChallengeAlreadyUsed,
  isInvitationCodeChallengeCanceled,
  isInvitationCodeChallengeExpired,
  isInvitationCodeChallengeLimitsReached,
  isInvitationCodeChallengeNotFound,
  isInvitationCodeChallengeRolesUnchanged,
  isInvitationCodeSignupAlreadyApproved,
  isInvitationCodeSignupAlreadyRejected,
  isInvitationCodeSignupApprovalRequest,
  isInvitationCodeSignupApprovalResponse,
  isInvitationCodeSignupApproved,
  isInvitationCodeSignupRejected,
  isInvitationCodeSignupRequest,
  isInvitationCodeUseRequest,
  isInvitationSignupChallenge,
  isInvitationSignupChallengeAlreadyAccepted,
  isInvitationSignupChallengeCanceled,
  isInvitationSignupChallengeEmailVerificationRequired,
  isInvitationSignupChallengeExpired,
  isInvitationSignupChallengeValidationErrors,
  isInvitationSignupRequest,
  isInvitationSignupResponse,
  isPasswordIncorrect,
  isPasswordRequired,
  isResetPasswordFailed,
  isResetPasswordRequest,
  isResetPasswordResult,
  isResetPasswordSignInRequired,
  isResetPasswordSignedIn,
  isResetPasswordToken,
  isSigninChallenge,
  isSigninRequest,
  isSigninResponse,
  isSigninSuccess,
  isSignupChallenge,
  isSignupChallengeCodeCanceled,
  isSignupChallengeCodeExpired,
  isSignupChallengeCodeNotFound,
  isSignupChallengeEmailVerificationRequired,
  isSignupChallengeLimitsReached,
  isSignupChallengeValidationErrors,
  isSignupResponse,
  isTermsNotAccepted,
  isWorkspaceAccessDenied,
  isWorkspaceAccessDeniedReason,
  isWorkspaceAccessGranted,
  isWorkspaceAccessUnapproved
});
//# sourceMappingURL=types.generated.js.map
